import { Slide } from '../types'
import { createReducer, createAction } from '@reduxjs/toolkit'

export interface SlidesReducer {
  scale: number
  slide: Slide
  drawLines: boolean
  user: 'student' | 'tutor' | null
  lines: { x: number; y: number }[][]
  cursorEnabled: boolean
  cursorPosition: {
    x: number
    y: number
  }
}

const initialState: SlidesReducer = {
  scale: 1,
  user: null,
  drawLines: false,
  lines: [],
  slide: {
    id: 0,
    html: '',
    position: 0
  },
  cursorEnabled: false,
  cursorPosition: {
    x: 0,
    y: 0
  }
}

export const SET_SLIDE = createAction<Slide>('slides_reducer/set_slide')
export const HANDLE_WS_SLIDE_MESSAGE = createAction<any>('slides_reducer/handle_ws_slide_message')
export const SET_CURSOR_POSITION = createAction<{ x: number; y: number }>('slides_reducer/set_cursor_position')

export const TOGGLE_CURSOR = createAction('slides_reducer/toggle_cursor')
export const UNDO_LINE = createAction('slides_reducer/undo_line')

interface SetDrawLinesPayload {
  drawLines: boolean
}
export const SET_DRAW_LINES = createAction<SetDrawLinesPayload>('slides_reducer/set_draw_lines')

export const ADD_LINE_COORDINATES = createAction<{ x: number; y: number }>('slides_reducer/add_line_coordinates')
export const ADD_LINE = createAction('slides_reducer/add_line')
export const CLEAR_LINES = createAction('slides_reducer/clear_lines')

interface SetUserPayload {
  user: SlidesReducer['user']
}
export const SET_USER = createAction<SetUserPayload>('slides_reducer/set_user')

interface SetScalePayload {
  scale: number
}
export const SET_SCALE = createAction<SetScalePayload>('slides_reducer/set_scale')

export const slidesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SET_SLIDE, (state, action) => {
      return { ...state, slide: action.payload }
    })
    .addCase(SET_CURSOR_POSITION, (state, action) => {
      state.cursorPosition = action.payload
      return state
    })
    .addCase(TOGGLE_CURSOR, (state) => {
      return { ...state, cursorEnabled: !state.cursorEnabled }
    })
    .addCase(SET_USER, (state, action) => {
      return { ...state, user: action.payload.user }
    })
    .addCase(SET_DRAW_LINES, (state, action) => {
      return { ...state, drawLines: action.payload.drawLines }
    })
    .addCase(ADD_LINE_COORDINATES, (state, action) => {
      const currentLine = state.lines.length > 0 ? state.lines[state.lines.length - 1] : []
      state.lines = [...state.lines.slice(0, -1), [...currentLine, action.payload]]
      return state
    })
    .addCase(ADD_LINE, (state) => {
      state.lines = [...state.lines, []]
      return state
    })
    .addCase(UNDO_LINE, (state) => {
      state.lines = state.lines.slice(0, -1)
      return state
    })
    .addCase(CLEAR_LINES, (state) => {
      state.lines = []
      return state
    })
    .addCase(SET_SCALE, (state, action) => {
      return { ...state, scale: action.payload.scale }
    })
})
